/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postLocationLogReport = (params) =>
  makeApiCall(`/user/location-log/report`, 'POST', params);
